import { format } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { FiAward } from 'react-icons/fi';
import useFetchData from '../../../hooks/useFetchData';

const ThisMonthProfit = () => {
    const { items: profit } = useFetchData("https://servers.thakurgaonexpress.com/rupkotha/daywiseprofit");
    const TotalProfit = (Array.isArray(profit) ? profit : []).reduce((total, currentValue) => total + (Number(currentValue?.profit) || 0), 0);


    return (
        // <div class="mx-auto w-11/12 bg-coral text-textPrimary rounded-lg overflow-hidden bg-[#ECECFF] shadow-lg glassmorphism p-5">
        <div class="modern-card p-5">
            <div className='flex justify-between items-center'>
                <div class="flex flex-col justify-center items-center">
                    <div class="text-sm font-semibold mb-2">This Month Profit</div>
                    <p class="text-xl text-textPrimary">৳ {TotalProfit.toFixed(2)}</p>
                </div>
                <div className="dashboard-stat-card__icon"><FiAward /></div>
            </div>
        </div>

    );
};

export default ThisMonthProfit;
